export const getUser = (state: any) => state?.userReducer?.user;
